import styled from "styled-components";

import SearchForm from "../../components/design/layout/search";

export const Form = styled(SearchForm)`
    flex-direction: row;
    padding-right: 0;
    padding-left: 15px;

    input[type=text],
    input[type=search],
    button[type=submit] {
        height: 38px
    }

`;

export const WrapperContent = styled.div`
    position: fixed;
    top: 57px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: ${(props) => props.zIndex};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
    background-color: ${({ theme }) => theme.color.xLight};
    padding-top: 0;
`;

export const ProductsGrid = styled.div`
    margin-top: 1.5625rem;
    width: 100%;
`;

export const WrappLoadMore = styled.div`
    text-align: center;
    margin-top: 15px;
    padding-bottom: 15px;
`;

export const QueryStatus = styled.div`
    background-color: ${({ theme }) => theme.color.extraLight};
    color: #8B8B8B;
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw600};
    border-bottom: 1px solid ${({ theme }) => theme.color.light};
    padding: 0.625rem 0.9375rem;
`;

export const StatusText = styled.span`
    color: ${({ theme }) => theme.color.black};
    font-size: 0.8125rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
`;

export const FilterButton = styled.button`
    color: ${({ theme }) => theme.color.black};
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    border: 0;
    padding: 10px 0 10px 10px;
    background-color: ${({ theme }) => theme.color.transparent};
    min-width: 70px !important;

    svg {
        height: 14px;
        width: auto !important;

        path {
            fill: ${({ theme }) => theme.color.black};
        }
    }
`;

export const NoResultsBlock = styled.div`
    margin: 0 auto;
    margin-top: 50px;
    
    ${({ theme }) => theme.media("xs", `
        max-width: 320px;
    `)}
    
    ${({ theme }) => theme.media("md", `
        max-width: 440px;
    `)}
`;

export const ImageNoResults = styled.img`
    width: 100%;
`;

export const NoTitle = styled.div`
    text-align: center;
    font-size: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${({ theme }) => theme.color.black};
    margin-top: 15px;
`;

export const OptionsList = styled.ul`
    margin-top: 10px;
`;

export const OptionsListItem = styled.li`
    color: ${({ theme }) => theme.color.grayBold};
    list-style: none;
`;
